
export default {
	props: {
		modalMenu: Boolean
	}
}
